import { css } from '@emotion/react';
import { White } from '@constants/color';

export const content = css({
  width: 912,
  height: 952,
  padding: 64
});

export const title = css({
  fontWeight: 700,
  fontSize: 48,
  lineHeight: '62.4px',
  color: White.White10,
  paddingTop: 80
});

export const textContainer = css({
  display: 'flex',
  flexDirection: 'column'
});
